import React from "react"


import {FieldCSVImportPreviewProps} from "../../../../render/csv-import-preview";

export default function FieldTaskParentTask_CSVImportPreview(props:FieldCSVImportPreviewProps) {

    // now default = viewSmall

    const value = props.field.getViewValue(props.model)

    return <div className="ui5-property">#{value}</div>

}
